export * from './user-avatar-updated';

import { UserAvatarUpdatedMessageTemplateComponent } from './user-avatar-updated';

export const UserDialogMessageTemplates = 
[
    UserAvatarUpdatedMessageTemplateComponent
];